<div class="main-login-company">  
    <div class="container">
        <div class="left-section">
        <img src="/assets/logo_2x.png" alt="Conectio Logo" class="logo">
        <h2>{{ 'companyLogin.title' | translate }} <span class="highlight">Conectio</span></h2>
        <p>{{ 'companyLogin.subtitle' | translate }}</p>
        <p>{{ 'companyLogin.description' | translate }}</p>
        <h3>{{ 'companyLogin.advantages.title' | translate }}</h3>
        <ul>
            <li>{{ 'companyLogin.advantages.talent' | translate }}</li>
            <li>{{ 'companyLogin.advantages.match' | translate }}</li>
            <li>{{ 'companyLogin.advantages.access' | translate }}</li>
            <li>{{ 'companyLogin.advantages.support' | translate }}</li>
            <li>{{ 'companyLogin.advantages.partner' | translate }}</li>
        </ul>
        </div>
        <div class="right-section">
        <h2>{{ 'companyLogin.form.title' | translate }}</h2>
        <form [formGroup]="loginForm" autocomplete="off">
            <mat-form-field appearance="fill">
            <mat-label>{{ 'companyLogin.form.email' | translate }}</mat-label>
            <input matInput type="email" id="email" formControlName="email" name="email_register" required>
            </mat-form-field>
            
            <mat-form-field appearance="fill">
            <mat-label>{{ 'companyLogin.form.password' | translate }}</mat-label>
            <input matInput type="password" id="password" formControlName="password" name="password_register" required>
            </mat-form-field>
            
            <div *ngIf="errorMessage" class="error-message">
                {{ errorMessage }}
            </div>
            <ng-container *ngIf="!isLoading; else loading">
                <button mat-raised-button color="primary" type="submit" (click)="login()">
                    {{ 'companyLogin.form.loginButton' | translate }}
                </button>
            </ng-container>

            <div class="recover-password">
                <a [routerLink]="['/company/register']" class="recover-link">{{ 'companyLogin.form.noAccount' | translate }}</a>
                <br>
                <br>
                <a [routerLink]="['/company/recover-password']" class="recover-link">{{ 'companyLogin.form.forgotPassword' | translate }}</a>
            </div>
            <ng-template #loading>
                <img src="/assets/spinner.gif" alt="Loading" class="loading-gif">
            </ng-template>
        </form>
        </div>
    </div>
</div>